import { APIS } from "utils/constants";
import { axiosInstance } from ".";
import { IStripePlan } from "./interfaces/stripe";

export const getPlans = async (): Promise<{
  data: IStripePlan[];
}> => {
  const res = await axiosInstance.get(APIS.STRIPE.PLANS);
  return res.data;
};
interface ICreateSubscriptionParams {
  priceId: string;
  successURL: string;
  cancelURL: string;
}
export const createSubscription = async ({
  priceId,
  successURL,
  cancelURL
}: ICreateSubscriptionParams) => {
  const res = await axiosInstance.post(APIS.STRIPE.CREATE_SUBSCRIPTION, {
    priceId,
    successURL,
    cancelURL
  });
  return res.data;
};

interface IManageSubscriptionParams {
  returnURL: string;
}
export const manageSubscritpion = async (
  params: IManageSubscriptionParams
): Promise<string> => {
  const res = await axiosInstance.post(APIS.STRIPE.MANAGE_SUBSCRIPTION, params);
  return res.data;
};
interface ICurrentSubscription {
  priceId: string;
  plusPlusCount: number;
  plusPlusTrialLimit: number;
  subscribed: boolean;
  isFreeSubscription: boolean;
}
export const getCurrentSubscription =
  async (): Promise<ICurrentSubscription> => {
    const res = await axiosInstance.get(APIS.STRIPE.CURRENT_SUBSCRIPTION);
    return res.data;
  };
